module.exports = __webpack_public_path__ + "static/img/THOMAS-BURTON.1864921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/THOMAS-BURTON.jpg
// module id = KORu
// module chunks = 0